import { styled } from '@clickcease/cc-client-components-lib'

export const MicrosoftParamsTabStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const MicrosoftTabText = styled('div', {
  margin: '16px 0px 8px',
  fontWeight: 400,
  fontSize: '$md',
})
